import type { NavigateFunction } from "react-router-dom";

type ViewTransitionDocument = Document & {
  startViewTransition?: (update: () => void) => { finished: Promise<unknown> };
};

export type WorkspaceTransitionDirection = "enter" | "exit";

export function navigateWithWorkspaceTransition(
  navigate: NavigateFunction,
  to: string,
  direction: WorkspaceTransitionDirection
) {
  const root = document.documentElement;
  const viewTransitionDocument = document as ViewTransitionDocument;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reducedMotion || !viewTransitionDocument.startViewTransition) {
    navigate(to);
    return;
  }

  root.dataset.workspaceTransition = direction;
  const transition = viewTransitionDocument.startViewTransition(() => navigate(to));
  void transition.finished.finally(() => {
    delete root.dataset.workspaceTransition;
  });
}
